import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';
import AuthStore from '../module-auth';

export default {
    state,
    mutations,
    getters,
    actions,
    modules: {
        auth: AuthStore,
    },
    strict: process.env.NODE_ENV === 'development' ? true : false, // attention en production le strict mode doit etre désactivé
    // car il est couteux en perf
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/fundation-app-vuejs/src/concretejs/store/module-api/index.js
// module id = null
// module chunks = 